/* ==========================================================
   Joeba — Disable countries without blogs in nav popups
   ==========================================================
   Werkt voor zowel main-blog als main-article-v3.
   Landen zonder actieve blog krijgen disabled + visuele dimming.
   Bron van waarheid: handles hieronder (sync met assets/countries-data.js
   blogHandles per continent).
   ========================================================== */
(function(){
  'use strict';

  var BLOG_HANDLES = {
    europa: ['albanie','andorra','armenie','belgie','bosnie-herzegovina','bulgarije','cyprus','denemarken','duitsland','estland','finland','frankrijk','georgie','griekenland','hongarije','ierland','ijsland','italie','kosovo','kroatie','letland','litouwen','luxemburg','malta','moldavie','monaco','montenegro','nederland','noord-macedonie','noorwegen','oekraine','oostenrijk','polen','portugal','roemenie','san-marino','servie','slovenie','slowakije','spanje','tsjechie','turkije','verenigd-koninkrijk','wit-rusland','zweden','zwitserland'],
    azie: ['bahrein','cambodja','china','filipijnen','india','indonesie','israel','japan','jordanie','laos','maldiven','maleisie','myanmar','nepal','oezbekistan','oman','qatar','singapore','sri-lanka','taiwan','thailand','verenigde-arabische-emiraten','vietnam','zuid-korea'],
    afrika: ['egypte','ethiopie','ghana','kenia','madagaskar','marokko','mauritius','namibie','nigeria','oeganda','rwanda','senegal','seychellen','tanzania','tunesie','zimbabwe','zuid-afrika'],
    'noord-amerika': ['aruba','bonaire','canada','costa-rica','cuba','curacao','dominicaanse-republiek','guatemala','jamaica','mexico','panama','puerto-rico','verenigde-staten'],
    'zuid-amerika': ['argentinie','bolivia','brazilie','chili','colombia','ecuador','peru','suriname','uruguay'],
    oceanie: ['australie','cookeilanden','fiji','frans-polynesie','nieuw-caledonie','nieuw-zeeland','samoa','vanuatu']
  };

  var ACTIVE = Object.create(null);
  Object.keys(BLOG_HANDLES).forEach(function(c){
    BLOG_HANDLES[c].forEach(function(h){ ACTIVE[h] = true; });
  });
  /* ── PRIMARY SOURCE OF TRUTH ───────────────────────────
     window.__JOEBA_BLOG_COUNTS wordt server-side door
     Shopify Liquid gevuld op basis van blogs[handle].articles_count.
     Een land telt alleen als actief wanneer count > 0.
     Hiermee is een leeg Blog (bv. Oekraïne met 0 artikelen)
     automatisch disabled, zonder handmatige lijst-onderhoud. */
  function rebuildActive(){
    var src = window.__JOEBA_BLOG_COUNTS;
    if (src && typeof src === 'object') {
      var next = Object.create(null);
      for (var k in src) {
        if (Object.prototype.hasOwnProperty.call(src, k)) {
          var v = +src[k];
          if (v > 0) next[k] = true;
        }
      }
      ACTIVE = next;
      window.__JOEBA_ACTIVE_BLOG_HANDLES = ACTIVE;
      return true;
    }
    /* Fallback: window.COUNTRIES_DATA */
    if (window.COUNTRIES_DATA && typeof window.COUNTRIES_DATA.getAllBlogHandles === 'function') {
      try {
        var arr = window.COUNTRIES_DATA.getAllBlogHandles();
        if (arr && arr.length) {
          var n2 = Object.create(null);
          arr.forEach(function(h){ n2[h] = true; });
          ACTIVE = n2;
          window.__JOEBA_ACTIVE_BLOG_HANDLES = ACTIVE;
          return true;
        }
      } catch(e){}
    }
    return false;
  }
  rebuildActive();
  window.__JOEBA_ACTIVE_BLOG_HANDLES = ACTIVE;

  function hasBlog(handle){
    if (!handle) return false;
    if (!Object.keys(ACTIVE).length) rebuildActive();
    return !!ACTIVE[handle];
  }

  /* CSS injectie (1x) */
  if (!document.getElementById('jb-disabled-country-style')) {
    var st = document.createElement('style');
    st.id = 'jb-disabled-country-style';
    st.textContent =
      '.joeba-country-nav-layer__link.jb-no-blog,'
    + '.joeba-continent-dropdown__item.jb-no-blog,'
    + '.joeba-article-continent-dropdown__item.jb-no-blog{'
    +   'opacity:.32 !important;cursor:not-allowed !important;'
    +   'pointer-events:none !important;filter:grayscale(.6);'
    + '}'
    + '.joeba-country-nav-layer__link.jb-no-blog::after{content:none !important;}';
    document.head.appendChild(st);
  }

  function markNode(node){
    if (!node || node.nodeType !== 1) return;
    var handle = node.getAttribute('data-country-handle')
              || node.getAttribute('data-jb-country-handle');
    if (!handle) return;
    /* Probeer ACTIVE opnieuw te vullen als deze nog leeg is
       (BLOG_COUNTS kan later in de pagina-cyclus klaar zijn). */
    if (!Object.keys(ACTIVE).length) rebuildActive();
    if (hasBlog(handle)) {
      node.classList.remove('jb-no-blog');
      node.removeAttribute('aria-disabled');
      node.removeAttribute('title');
      if (node.tagName === 'BUTTON') node.disabled = false;
      return;
    }
    node.classList.add('jb-no-blog');
    node.setAttribute('aria-disabled', 'true');
    node.setAttribute('title', 'Voor dit land is nog geen reisgids beschikbaar');
    if (node.tagName === 'BUTTON') node.disabled = true;
  }

  function scan(root){
    (root || document).querySelectorAll(
      '.joeba-country-nav-layer__link[data-country-handle],' +
      '.joeba-continent-dropdown__item[data-jb-country-handle],' +
      '.joeba-article-continent-dropdown__item[data-jb-country-handle]'
    ).forEach(markNode);
  }

  /* Block clicks defensively (in case pointer-events bypass) */
  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest && e.target.closest('.jb-no-blog');
    if (t) { e.preventDefault(); e.stopPropagation(); if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation(); }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ scan(); });
  } else {
    scan();
  }
  window.addEventListener('load', function(){ scan(); });

  /* Re-scan when JS herrendert (dropdowns, continent-wissel) */
  if (window.MutationObserver) {
    var mo = new MutationObserver(function(muts){
      for (var i=0; i<muts.length; i++) {
        var m = muts[i];
        if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
          for (var j=0; j<m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType === 1) {
              if (n.matches && (n.matches('.joeba-country-nav-layer__link[data-country-handle]') || n.matches('.joeba-continent-dropdown__item[data-jb-country-handle]') || n.matches('.joeba-article-continent-dropdown__item[data-jb-country-handle]'))) {
                markNode(n);
              } else if (n.querySelectorAll) {
                scan(n);
              }
            }
          }
        }
      }
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('joeba:country-nav-rendered', function(e){ scan(e.detail && e.detail.root ? e.detail.root : document); });
  window.jbCountryHasBlog = hasBlog;
  window.jbRescanEmptyCountries = function(root){ rebuildActive(); scan(root || document); };
})();